import api from "api"

export async function loadScenarioGoals(store, scenario_id) {
  const goals = await api.get(`scenarios/${scenario_id}/goals`)

  let alreadyLoaded = false
  if (goals.length === 0) {
    const state = store.getState()
    const household_id = state.user.group_id
    const subscription = state.subscriptions[household_id]
    const isCOVID =
      subscription && subscription.features && subscription.features.is_covid
    if (isCOVID) {
      try {
        const covid = await api.get(
          `households/${household_id}/interviews/covid`
        )
        if (covid && covid.client && covid.client.subtype !== "normal") {
          const { eshc_plan_status, ...goalData } = covid.client
          const clients = Object.values(state.people).filter(
            person => person.role === "client"
          )
          if (clients.length > 0) {
            const person_id = clients[0]["id"]
            await store.actions.addGoal({
              type: "workpause",
              household_id,
              scenario_id,
              person_id,
              ...goalData
            })
            alreadyLoaded = true
          }
        }
        if (
          covid &&
          covid.is_married &&
          covid.spouse &&
          covid.spouse.subtype !== "normal"
        ) {
          const { eshc_plan_status, ...goalData } = covid.spouse
          const spouses = Object.values(state.people).filter(
            person => person.role === "spouse"
          )
          if (spouses.length > 0) {
            const person_id = spouses[0]["id"]
            await store.actions.addGoal({
              type: "workpause",
              household_id,
              scenario_id,
              person_id,
              ...goalData
            })
            alreadyLoaded = true
          }
        }
      } catch (error) {
        console.error("unable to fetch interview data")
      }
    }
  }

  if (!alreadyLoaded) {
    await store.update(state => {
      state.scenarioGoalIds[scenario_id] = goals.map(goal => goal.id)
      goals.forEach(goal => {
        state.goals[goal.id] = goal
      })
    })
  }
}

export async function loadGoal(store, goal_id) {
  const goal = await api.get(`goals/${goal_id}`)
  await store.update(state => {
    state.goals[goal.id] = goal
  })
}

export async function addGoal(
  store,
  { scenario_id, household_id, ...goalDetails }
) {
  const goal = await api.post(
    `scenarios/${scenario_id}/goals`,
    undefined,
    goalDetails
  )

  await store.update(state => {
    if (!state.scenarioGoalIds[scenario_id]) {
      state.scenarioGoalIds[scenario_id] = []
    }
    state.scenarioGoalIds[scenario_id].push(goal.id)
    state.goals[goal.id] = goal
  })
}

export async function updateGoal(store, { id, ...goalDetails }) {
  const goal = await api.patch(`goals/${id}`, undefined, goalDetails)

  await store.update(state => {
    state.goals[goal.id] = goal
  })
}

export async function deleteGoal(store, { scenario_id, id }) {
  await api.delete(`scenarios/${scenario_id}/goals/${id}`)
  await store.update(state => {
    state.scenarioGoalIds[scenario_id].splice(
      state.scenarioGoalIds[scenario_id].findIndex(goalId => goalId === id),
      1
    )
  })
}
